export default "dist/images/rect.jpg"